import React from 'react';
import ServicePageTemplate from '@/components/ServicePageTemplate';

const ChavesPage: React.FC = () => {
  return <ServicePageTemplate serviceSlug="chaves" />;
};

export default ChavesPage;